{
  "$comment": "Production trust registry for federation remote-loading integrity. The actual root of trust for Stage A/B verification -- see mfe-pot/docs/plans/20260811-1500-federation-remote-loading-integrity.md. Entries are added only via a reviewed PR to this repo (never self-service, never written by CI). Phase 2 rollout: all 4 remotes now signing, msca-shell verifying.",
  "version": 1,
  "remotes": {
    "job-bank-mfe": {
      "kid": "job-bank-mfe-2026",
      "publicKeyJwk": {
        "kty": "RSA",
        "n": "xyNCQ2IZ3HqGhbYGfGc4of9wfXSc1nPlV1yS5ctkEtuKP7YuPB3EpYH1jeDK9nuujCtkqrMiJpqKxitj7eiStWWbZi-heHBGP3PFLgUeBB7BFZkSjOfH6JrrHOcM-b9mKG9qPhzk7Sfvbtrq_63M5S8RRQ96iRMojZH8lbr4IY-i5FC6PUbVorAYX503TyGXK8Fv7uCsyXai5mm8A_hz6i2TFRN-aZ7h0ubN0Q5n-aa2czQmOOF-JOqoqFB0qrgg6RDSDFgl9ZNwrbABeuI16JJWcDF4IljyxVWjcZsX0057iIwn6fV8JPGYbIgBW1534oBClnRtBPf15l3C5KsXIw",
        "e": "AQAB"
      },
      "alg": "RS256",
      "allowedOrigins": [
        "http://job-bank-mfe.mfe-pot.local",
        "https://job-bank-mfe.mfe-pot.accenture.com"
      ],
      "provisioning": "first-party-ci"
    },
    "dashboard-mfe": {
      "kid": "dashboard-mfe-2026",
      "publicKeyJwk": {
        "kty": "RSA",
        "n": "1k9fkTIVL8WEgJc8xY7D3r8nMyYHbK7hbJf7gWTKnH876hZfW4B1DDb44JzFlcaPBpOOCm6CmEsgZKFxlZSZi5hSLHvRXru7NLECKwLn5tEYx1Eyi-oa9dLaWIcYJu-xZp5bwX0MSBGxtWgA081GRMJ7MkDOkuLs7NpDS2jvT_ds7ZeKBzJGOcre7_7UdxrtCO8HAkX_fbPEmi50xSZTeLg0t5Kjne5G5zfN5D-FqZeSoYiWTDyrY_HaX4097vdE2Hcr9GJmRb0CTvAmaZx6_ZK36c4boA35wV0p2FjhzgylpsBHz84iX36WdI8nY5vtpH6zeYqJW3G_mCmzmdWmYQ",
        "e": "AQAB"
      },
      "alg": "RS256",
      "allowedOrigins": [
        "http://dashboard-mfe.mfe-pot.local",
        "https://dashboard-mfe.mfe-pot.accenture.com"
      ],
      "provisioning": "first-party-ci"
    },
    "employment-insurance-mfe": {
      "kid": "employment-insurance-mfe-2026",
      "publicKeyJwk": {
        "kty": "RSA",
        "n": "rRhIjljMSLY4UXfHJeaU5DOfPIRDcDZNl-WbegDOTXuKfMOr3aSwxFIhBKnprhGbu0-71Zmllt0ZZV-XICgJXL7QpIurZHDDETHUVCgCkOVyvD5mtxXn8bWM0vpyu2l7bbYhuBFsWib-dr6T7Qy-jZShl3o8hTNhXXuUrGCSmZQA4LVJakf79pgBmZavCIhjzJ5m4JZnW_mPLw1NMc9ahsbUPPlSOhJFFOzSVo4jrZp65Y6KlLMdmx8ObO7j-dAfeCHnsBM22QlXbngRwwiE5UeG2i3nNznSrQb7PxO4wxPx_7UasGDYVkAykiq76bkvrzGAX0IqhWi7Yt4YvqwssQ",
        "e": "AQAB"
      },
      "alg": "RS256",
      "allowedOrigins": [
        "http://employment-insurance-mfe.mfe-pot.local",
        "https://employment-insurance-mfe.mfe-pot.accenture.com"
      ],
      "provisioning": "first-party-ci"
    },
    "life-events-mfe": {
      "kid": "life-events-mfe-2026",
      "publicKeyJwk": {
        "kty": "RSA",
        "n": "1zUYb7Y_AB1qjgP0SzzvEeE-IFyJ7-IzBe___n0hV0EpwO85fMCBgu5tHquKP9RBM5bfy_nXxYMglCs5wUv5MCNz9mJMsPXG-utfP5Ks5vN3BEXjzNxzzDSGM7dJYgLL0qdyivufs2N5HUgePPO2NdxWKe802ECLhXjuiindTC31ZAxrpIR9mYt4a279K7UCrwhKm2pojG-8RmBZUSpVlpM6BwxDPE0B2S67IYddLBV_vSFKs9_OvLEyc8-022PtDsrp9KhDEdtbTykqIoWw44oiR0asixc15fIgWDQlQXl9MvhqqnPvxoRVg9gA7eH99_IjwKSzc1RsMSg0oJ_o-w",
        "e": "AQAB"
      },
      "alg": "RS256",
      "allowedOrigins": [
        "http://life-events-mfe.mfe-pot.local",
        "https://life-events-mfe.mfe-pot.accenture.com"
      ],
      "provisioning": "first-party-ci"
    }
  }
}
